import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

// The mutation re-selects the company's blocks so the Relay store learns about the new one
// immediately — the section dropdown updates without a refetch.
const mutation = graphql`
	mutation createQuoteContentBlockMutation($input: CreateQuoteContentBlockInput!) {
		createQuoteContentBlock(input: $input) {
			company {
				id
				quoteContentBlocks {
					id
					sectionType
					name
					bodyJson
					isDefault
				}
			}
			quoteContentBlock {
				id
				sectionType
				name
				bodyJson
				isDefault
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
